import { EarningsInsightRating } from '@api';
import { useTranslation } from 'react-i18next';

import styles from './RatingPill.module.scss';
import { getRatingColors } from './utils';

export interface RatingPillProps {
  rating: EarningsInsightRating;
}

export const RatingPill = ({ rating }: RatingPillProps) => {
  const { t } = useTranslation(['earnings']);
  const { backgroundColor, textColor } = getRatingColors(rating);

  return (
    <div className={styles.ratingWrapper} style={{ backgroundColor }}>
      <span className={styles.ratingLabel} style={{ color: textColor }}>
        {t(`earnings:earningsInsight.metadata.rating.${rating}`)}
      </span>
    </div>
  );
};
